import { RowData } from "@tanstack/react-table";

import {
  ConfigurationViewConfig,
  DatatableConfigurationView,
} from "./datatable-configuration-view/datatable-configuration-view";
import { DatatableList } from "./datatable-list/datatable-list";
import { DatatableAppliedFilterView } from "./datatable-applied-filter-view";

interface DatatableBodyProps {
  config?: ConfigurationViewConfig;
}

export function DatatableBody<TData extends RowData>({ config }: DatatableBodyProps) {
  return (
    <div className="flex h-full max-h-full w-full flex-col overflow-y-hidden">
      <DatatableConfigurationView config={config} />
      <DatatableAppliedFilterView />
      <DatatableList<TData> />
    </div>
  );
}
